// extracted by mini-css-extract-plugin
export default {"TrailingNegateButton":"FacetNegateButton-module__TrailingNegateButton--DkmYC"};